import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { 
  Lightbulb, 
  Share2, 
  MessageSquare, 
  Star, 
  TrendingUp,
  Target,
  Sparkles
} from 'lucide-react';

const tips = [
  {
    icon: Share2,
    title: 'Sosyal Medyada Paylaşın',
    description: 'Kursunuzu Instagram, LinkedIn ve diğer platformlarda tanıtın.',
    color: 'text-blue-600 bg-blue-100'
  },
  {
    icon: MessageSquare,
    title: 'Toplulukta Aktif Olun',
    description: 'Pilatika topluluğunda sorulara cevap verin, değer katın.',
    color: 'text-purple-600 bg-purple-100'
  },
  {
    icon: Star,
    title: 'Kaliteli İçerik Üretin',
    description: 'Detaylı açıklama ve profesyonel kapak görseli ekleyin.',
    color: 'text-yellow-600 bg-yellow-100'
  },
  {
    icon: Target,
    title: 'Doğru Fiyatlandırma',
    description: 'Önerilen fiyat aralığında kalarak rekabetçi olun.',
    color: 'text-green-600 bg-green-100'
  }
];

export const FirstSaleTips = () => {
  return (
    <Card className="border-dashed border-2 border-purple-200 bg-gradient-to-br from-purple-50 to-pink-50">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-purple-800">
          <Sparkles className="h-5 w-5" />
          İlk Satışınız İçin İpuçları
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-4">
          {tips.map((tip, index) => (
            <div key={index} className="flex items-start gap-3 p-3 bg-white rounded-lg shadow-sm">
              <div className={`p-2 rounded-full ${tip.color}`}>
                <tip.icon className="h-4 w-4" />
              </div>
              <div>
                <h4 className="font-medium text-gray-900">{tip.title}</h4>
                <p className="text-sm text-gray-600">{tip.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-4 p-3 bg-white rounded-lg border border-purple-200">
          <div className="flex items-center gap-2 text-purple-800 mb-2">
            <Lightbulb className="h-4 w-4" />
            <span className="font-medium">Bilgi</span>
          </div>
          <p className="text-sm text-gray-600">
            İlk satışınızı yaptığınızda size özel <strong>&quot;İlk Satış&quot;</strong> rozeti kazanacaksınız! 
            10 satışa ulaştığınızda <strong>&quot;Yıldız Eğitmen&quot;</strong> rozetini açabilirsiniz.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default FirstSaleTips;
